class EmailComposerError extends Error {
  constructor(reason) {
    super(reason);
    this.name = 'EmailComposerError';
  }
}

export default EmailComposerError;
